import React, { useContext, useState, useEffect } from 'react';
import { Card, Typography, Row, Col, message, Modal, DatePicker, Button, Spin, Select } from 'antd';
import axios from 'axios';
import { LoginContext } from '../../../context/loginContext';

const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;

const CReportesAdministrador = () => {
    const { user, selectedEmpresa } = useContext(LoginContext);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalCuentaVisible, setIsModalCuentaVisible] = useState(false);
    const [isModalMovimientosVisible, setIsModalMovimientosVisible] = useState(false);
    const [dates, setDates] = useState([]);
    const [datesMovimientos, setDatesMovimientos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cuentaSeleccionada, setCuentaSeleccionada] = useState(null);
    const [listaCuentas, setListaCuentas] = useState([]);
    const [cuentasFiltradas, setCuentasFiltradas] = useState([]);

    // Cargar cuentas del plan al montar el componente
    useEffect(() => {
        if (selectedEmpresa?.emp_id) {
            fetchCuentasPlan();
        }
    }, [selectedEmpresa]);

    const showDateModal = () => {
        setIsModalVisible(true);
    };

    const showCuentaModal = () => {
        setIsModalCuentaVisible(true);
    };

    const showMovimientosModal = () => {
        setIsModalMovimientosVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleCancelCuenta = () => {
        setIsModalCuentaVisible(false);
        setCuentaSeleccionada(null);
    };

    const handleCancelMovimientos = () => {
        setIsModalMovimientosVisible(false);
        // No resetear las fechas aquí para mantener la selección
    };

    const handleDownloadEstadoResultados = async () => {
        if (!dates || dates.length < 2) {
            message.warning('Por favor selecciona un rango de fechas.');
            return;
        }
        setLoading(true);
        const [fechaInicio, fechaFin] = dates.map(date => date.format('YYYY-MM-DD'));
        setIsModalVisible(false);

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/pdf/estado-resultado/${selectedEmpresa.emp_id}/${fechaInicio}/${fechaFin}`,
                { 
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${user.token}`,
                    }
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'estado_resultado.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoading(false);
            message.success('Estado de Resultados descargado');
        } catch (error) {
            if (error.response && error.response.status === 404) {
                const errorMessage = error.response.data.message || 'Estado de resultados no encontrado';
                setLoading(false);
                message.error(errorMessage);
            } else {
                setLoading(false);
                message.error('Error al cargar los pagos');
            }
        }
    };

    // Función para obtener cuentas del plan
    const fetchCuentasPlan = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/plan-cuenta/${selectedEmpresa.emp_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${user.token}`,
                    },
                }
            );
            setListaCuentas(response.data);
            setCuentasFiltradas(response.data);
        } catch (error) {
            message.error('Error al cargar cuentas del plan');
        }
    };

    // Función para filtrar cuentas
    const handleSearchCuentas = (value) => {
        if (!value) {
            setCuentasFiltradas(listaCuentas);
            return;
        }
        
        const filtradas = listaCuentas.filter(cuenta => 
            cuenta.pla_codigo.toLowerCase().includes(value.toLowerCase()) ||
            cuenta.pla_nombre.toLowerCase().includes(value.toLowerCase())
        );
        setCuentasFiltradas(filtradas);
    };

    // Función para generar reporte de cuenta específica
    const handleGenerarReporteCuenta = async () => {
        if (!cuentaSeleccionada) {
            message.warning('Por favor selecciona una cuenta');
            return;
        }
        if (!dates || dates.length < 2) {
            message.warning('Por favor selecciona un rango de fechas.');
            return;
        }
        
        setLoading(true);
        const [fechaInicio, fechaFin] = dates.map(date => date.format('YYYY-MM-DD'));
        setIsModalCuentaVisible(false);

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/pdf/reporte-cuenta-especifica/${selectedEmpresa.emp_id}/${fechaInicio}/${fechaFin}/${cuentaSeleccionada}`,
                { 
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${user.token}`,
                    }
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'reporte_cuenta_especifica.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoading(false);
            message.success('Reporte de Cuenta Específica descargado');
        } catch (error) {
            if (error.response && error.response.status === 404) {
                const errorMessage = error.response.data.message || 'No se encontraron movimientos para la cuenta seleccionada';
                setLoading(false);
                message.error(errorMessage);
            } else {
                setLoading(false);
                message.error('Error al generar el reporte');
            }
        }
    };

    const handleDownloadMovimientosDetallado = async () => {
        if (!datesMovimientos || datesMovimientos.length < 2) {
            message.warning('Por favor selecciona un rango de fechas.');
            return;
        }
        
        setLoading(true);
        const [fechaInicio, fechaFin] = datesMovimientos.map(date => date.format('YYYY-MM-DD'));
        setIsModalMovimientosVisible(false);

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/pdf/reporte-movimientos-detallado/${selectedEmpresa.emp_id}/${fechaInicio}/${fechaFin}`,
                { 
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${user.token}`,
                    }
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'reporte_movimientos_detallado.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setLoading(false);
            message.success('Reporte de Movimientos Detallado descargado');
        } catch (error) {
            if (error.response && error.response.status === 404) {
                const errorMessage = error.response.data.message || 'No se encontraron movimientos para el período especificado';
                setLoading(false);
                message.error(errorMessage);
            } else {
                setLoading(false);
                message.error('Error al generar el reporte');
            }
        }
    };

    const reportes = [
        { key: 'planCuentas', title: 'Plan de Cuentas', action: () => fetchPlanCuentas() },
        { key: 'cuentas', title: 'Cuentas', action: () => fetchCuentas() },
        { key: 'estadoResultados', title: 'Estado de Resultados', action: showDateModal },
        { key: 'cuentaEspecifica', title: 'Reporte Cuenta Específica', action: showCuentaModal },
        { key: 'movimientosDetallado', title: 'Reporte Movimientos Detallado', action: showMovimientosModal },
        { key: 'chequesAVencer', title: 'Cheques a vencer' }
    ];

    const fetchPlanCuentas = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/pdf/plan-de-cuenta/${selectedEmpresa.emp_id}`,
                { 
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${user.token}`,
                    }
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'plan_de_cuenta.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setLoading(false);
            message.success('Plan de Cuentas descargado');
        } catch (error) {
            setLoading(false);
            message.error('Error al descargar Plan de Cuentas');
        }
    };

    const fetchCuentas = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/pdf/cuentas/${selectedEmpresa.emp_id}`,
                { 
                    responseType: 'blob',
                    headers: {
                        Authorization: `Bearer ${user.token}`,
                    }
                }
            );

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'cuentas_empresa.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setLoading(false);
            message.success('Cuentas descargadas');
        } catch (error) {
            setLoading(false);
            message.error('Error al descargar Cuentas');
        }
    };

    return (
        <div style={{ padding: '40px', minHeight: '100vh' }}>
            {loading && (
                <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000 }}>
                    <Spin size="large" />
                </div>
            )}
            <Title level={2} style={{ textAlign: 'center', marginBottom: '32px' }}>
                Reportes Administrador
            </Title>
            <Row gutter={[24, 24]} justify="center">
                {reportes.map((reporte) => (
                    <Col key={reporte.key} xs={24} sm={12} md={8} lg={8}>
                        <Card
                            hoverable
                            onClick={reporte.action}
                            style={{ textAlign: 'center', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(228, 155, 86, 0.42)' }}
                        >
                            <Title level={4} style={{ margin: 0 }}>{reporte.title}</Title>
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* Modal de selección de fechas */}
            <Modal
                title="Selecciona el rango de fechas"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleDownloadEstadoResultados}>
                        Descargar
                    </Button>
                ]}
            >
                <RangePicker onChange={setDates} format="DD/MM/YYYY" style={{ width: '100%' }} />
            </Modal>

            {/* Modal de selección de cuenta específica */}
            <Modal
                title="Reporte de Cuenta Específica"
                open={isModalCuentaVisible}
                onCancel={handleCancelCuenta}
                footer={[
                    <Button key="cancel" onClick={handleCancelCuenta}>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleGenerarReporteCuenta}>
                        Generar Reporte
                    </Button>
                ]}
                width={600}
            >
                <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                        Selecciona el rango de fechas:
                    </label>
                    <RangePicker onChange={setDates} format="DD/MM/YYYY" style={{ width: '100%' }} />
                </div>
                <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                        Selecciona una cuenta del plan:
                    </label>
                    <Select
                        placeholder="Selecciona una cuenta"
                        style={{ width: '100%' }}
                        value={cuentaSeleccionada}
                        onChange={setCuentaSeleccionada}
                        showSearch
                        onSearch={handleSearchCuentas}
                        filterOption={false}
                        notFoundContent="No se encontraron cuentas"
                        loading={listaCuentas.length === 0}
                    >
                        {cuentasFiltradas.map((cuenta) => (
                            <Option key={cuenta.pla_id} value={cuenta.pla_id}>
                                {cuenta.pla_codigo} - {cuenta.pla_nombre}
                            </Option>
                        ))}
                    </Select>
                </div>
            </Modal>

            {/* Modal de selección de fechas para movimientos detallado */}
            <Modal
                title="Reporte de Movimientos Detallado"
                open={isModalMovimientosVisible}
                onCancel={handleCancelMovimientos}
                footer={[
                    <Button key="cancel" onClick={handleCancelMovimientos}>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleDownloadMovimientosDetallado}>
                        Descargar
                    </Button>
                ]}
            >
                <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                        Selecciona el rango de fechas:
                    </label>
                    <RangePicker onChange={setDatesMovimientos} format="DD/MM/YYYY" style={{ width: '100%' }} />
                </div>
                <div style={{ marginTop: '16px', padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '6px' }}>
                    <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
                        Este reporte incluye todos los movimientos del período seleccionado con los siguientes datos:
                    </p>
                    <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px', fontSize: '14px', color: '#666' }}>
                        <li>Fecha de origen del comprobante</li>
                        <li>Cuenta</li>
                        <li>Tipo de comprobante</li>
                        <li>Punto de venta</li>
                        <li>Número</li>
                        <li>Subtotal</li>
                        <li>IVA</li>
                        <li>Total</li>
                    </ul>
                </div>
            </Modal>
        </div>
    );
};

export default CReportesAdministrador;